import * as React from "react"

import gsap from "gsap"; // <-- import GSAP
import { useGSAP } from "@gsap/react"; // <-- import the hook from our React package

import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default function Icon() {

  useGSAP(() => {

    let tl = gsap.timeline({
      defaults: {
        duration: 1.2,
        ease: 'power1.inOut',
      },
      scrollTrigger: {
        trigger: "#icon-bacteria",
        start: "bottom bottom",
        end: "bottom+=50px bottom",
        markers: false,
        toggleActions: "play none play reset"
      }
    });

    tl.from('#icon-bacteria', { 
        duration: 1,
				rotate: 360,
        transformOrigin: "center center",
      })
      // .to('.circle-b', {
			// 	opacity: 0,
      //   scale: 0,
			// 	stagger: 0.3,
      // })
			// .to('.circle-b', {
			// 	opacity: 1,
      //   scale: 1,
      // })
  });

 return (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108.28 108.27" id="icon-bacteria">
		<circle className="bacteria" cx="54.14" cy="54.13" r="39.09" fill="none" stroke="#001e5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/>
		<circle className="circle-b" cx="47.62" cy="36.75" r="5.43" fill="none" stroke="#001e5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/>
		<circle className="circle-b" cx="69.34" cy="49.78" r="6.51" fill="none" stroke="#001e5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/>
		<circle className="circle-b" cx="45.45" cy="64.98" r="8.69" fill="none" stroke="#001e5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/>
		<path fill="none" stroke="#001e5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M54.14 15.06s-.02 0-.02-.02V2.01s.04-.03.04 0v13.03s0 .02-.02.02Zm0 91.21s-.02 0-.02-.02V93.22s.04-.03.04 0v13.03s0 .02-.02.02ZM26.5 26.51h-.01l-9.21-9.21v-.03h.03l9.21 9.21v.03h-.02ZM90.99 91h-.01l-9.21-9.21v-.03h.03l9.21 9.21V91h-.02ZM15.05 54.15H2.02s-.02 0-.02-.02 0-.02.02-.02h13.03s.02 0 .02.02 0 .02-.02.02Zm91.21 0H93.23s-.02 0-.02-.02 0-.02.02-.02h13.03s.02 0 .02.02 0 .02-.02.02ZM17.29 91h-.01v-.03l9.21-9.21h.03v.03L17.31 91h-.02Zm64.49-64.49h-.01v-.03l9.21-9.21h.03v.03l-9.21 9.21h-.02Z"/>
	</svg>
 );
}